var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Modal", { ref: "modal" }, [
    _c(
      "div",
      { attrs: { slot: "content" }, slot: "content" },
      [
        _c("p", { staticClass: "modal-pure-text" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("userManagement.inviteTip", [_vm.masterAccountFullName])
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.needFloors
          ? [
              _c("p", { staticClass: "modal-pure-text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("userManagement.selectFloorTip")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-pure-text tenancy-floor" }, [
                _c("span", { staticClass: "required-flag" }, [
                  _vm._v(_vm._s(_vm.$t("tenancy.floor"))),
                ]),
                _vm._v(":\n        "),
                _c(
                  "div",
                  { staticClass: "floor-select" },
                  [
                    _c("MasterInviteModalFloorSelect", {
                      staticClass: "modal-select",
                      model: {
                        value: _vm.masterFloors,
                        callback: function ($$v) {
                          _vm.masterFloors = $$v
                        },
                        expression: "masterFloors",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
      _c(
        "button",
        { staticClass: "btn btn--darkblue", on: { click: _vm.close } },
        [_vm._v("\n      " + _vm._s(_vm.$t("action.cancel")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn--orange",
          on: {
            click: function () {
              return _vm.doInvite()
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("action.invite")) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }